import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer'
import './shoppingCart.css'
import Beard from '../../assets/images/logo-beard2.svg'
import PenTool from '../../assets/icons/pen-tool.svg'
import GiftImg from '../../assets/images/gift-img2.svg'
import FastLoginCom from '../fastLogin/fastLogin'
import { useCart } from '../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import { imgBaseUrl ,getBasketList,setCountBasketList, deleteFromBasket} from '../../utils/api';
import useToastNotification from '../../hooks/useToastNotification';

function ShoppingCart() {
    const [items, setItems] = useState([]);
    const [fastLogin, setFastLogin] = useState(false);
    const { addToCart } = useCart();
    const { cartItems } = useCart();
    const navigate = useNavigate();
    const { showError, showSuccess } = useToastNotification();

    useEffect(() => {
        openBasket()
    }, []);
     const openBasket = async (event) => {
            let clientId = localStorage.getItem('clientId')
            try {
                let res = await getBasketList(clientId)
                if (res.data.isSuccess) {
                    setItems(res.data.data)
                }
            } catch (error) {
    
            }
          
        };

    useEffect(() => {
        addToCart();
    }, [items]); // نظارت بر تغییرات آیتم‌ها

 const changeCountProduct = async (updatedQuantity, product) => {
        try {
            let pay = {
                clientId: localStorage.getItem('clientId'),
                basketId: product.basketId,
                count: updatedQuantity
            };
            //console.log(pay);
            let res = await setCountBasketList(pay);
            //console.log(res)
            if (!res.data.isSuccess) {
                showError(res.data.message)
                return false;
                // بعد از موفقیت‌آمیز بودن تغییر، لیست را مجدداً از سرور دریافت کنید
                // let updatedBasket = await getBasketList(localStorage.getItem('clientId'));
                // if (updatedBasket.data.isSuccess) {
                //     setItems(updatedBasket.data.data);
                // }
            }
        } catch (error) {
            console.error("Error updating product count:", error);
            return false;
        }

        return true;
    };
    
    const changeQuantity = async (item, action) => {
        //console.log(item)
        if (item.productId) {
        // ابتدا مقدار جدید را محاسبه کنید
            const updatedCount = action === 'add' ? item.count + 1 : item.count - 1;
            
            if (updatedCount > 0) {
                // عملیات async را انجام دهید
                const res = await changeCountProduct(updatedCount, item);
                
                if (res) {
                    // اگر موفق بود، state را آپدیت کنید
                    setItems(oldItems =>
                        oldItems.map(oldItem => 
                            oldItem.basketId === item.basketId 
                                ? { ...oldItem, count: updatedCount }
                                : oldItem
                        )
                    );
                }
            } else {
                // اگر تعداد صفر شد، آیتم را حذف کنید
                removeFromCart(item);
            }
        }
        else {
            setItems(oldItems =>
                oldItems.map(oldItem => {
                    if (oldItem.productId === item.productId) {
                        const updatedCount = action === 'add' ? oldItem.count + 1 : oldItem.count - 1;

                        if (updatedCount > 0) {
                            saveToLocalStorage(oldItem.productId, updatedCount);
                            return { ...oldItem, count: updatedCount };
                        } else {
                            removeFromCart(oldItem.productId); // Remove item if count reaches 0
                            // addToCart()
                            return null;
                        }
                    }
                    return oldItem;
                }).filter(Boolean)
            );
        }

    };

    const saveToLocalStorage = (productId, updatedQuantity, id) => {
        if (id) {

            const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
            const existingProductIndex = cartItems.findIndex(item => item.id === id);

            if (existingProductIndex >= 0) {
                cartItems[existingProductIndex].count = updatedQuantity;
            } else {
                cartItems.push({ id, count: updatedQuantity });
            }

            sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
            addToCart()
        } else {
            const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
            const existingProductIndex = cartItems.findIndex(item => item.productId === productId);

            if (existingProductIndex >= 0) {
                cartItems[existingProductIndex].count = updatedQuantity;
            } else {
                cartItems.push({ productId, count: updatedQuantity });
            }

            sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
            addToCart()
        }

    };
  const removeFromCart = async (item) => {
        try {
            let pay = {
                count: item.count,
                basketId: item.basketId,
                clientId: localStorage.getItem('clientId')
            }
            let res = await deleteFromBasket(pay)
            if(res.data.isSuccess){
                // showSuccess('محصول مورد نظر از سبد خرید حذف شد.')
                addToCart()
            }else{
                // showSuccess(res.data.message)
            }
        } catch (error) {

        }
        // const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];
        // const updatedCart = cartItems.filter(item => item.productId !== productId);
        // sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
    };


    useEffect(() => {
        addToCart()
        // const productData = sessionStorage.getItem('cartItems');
        // if (productData) {
        //     setItems(JSON.parse(productData));
        //     setTotalItems(JSON.parse(productData).length)
        // }
    }, []);
    const totalPrice = items.reduce((acc, item) => acc + (item.price * item.count), 0);


    const goToPayment = () => {
        navigate('/payment');
    };
    const checkLogin = () => {
        if (cartItems > 0) {
            if (localStorage.getItem('userData')) {
                window.location.href = '/payment';
            } else {
                setFastLogin(true);
            }
        }
    };
    return (
        <div>
            <div className='container'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />سبد خرید</div>
                <div className="flex align-items-center justify-between px-4 py-3 bg-white rounded-2xl mt-5">
                    <div>
                        <h5 className="font-bold">
                            کارت دلخواهت را طراحی کن
                        </h5>
                    </div>
                    <button className='btn btn-primary d-flex align-items-center gap-2 shop-btn' type='button' onClick={() => { window.location.href = '/design' }}> <img src={PenTool} alt="" />طراحی کارت</button>
                </div> {items.length > 0 ? (
                    <div className='row shop-cart gy-2' style={{marginBottom: '6em'}}>
                        <div className='col-md-8 col-sm-12 col-lg-8'>

                            {items.map(item => (
                                <div className='item mt-3 flex-revers'>
                                    <div className='img-box max-w-[100%] mx-auto'>
                                        <div className="relative overflow-hidden">
                                            <img className='max-w-[100%]' src={`data:image/png;base64,${item.imageBase64}`} alt="" />
                                            {/* <img src={require('../../assets/images/design/preview-bg.png')} className='absolute inset-0 z-10 !w-full !h-full' alt="" /> */}
                                        </div>
                                    </div>
                                    <div className='flex-1 text-right w-100'>
                                        <div className='text-[#0033CC] text-2xl font-bold'>{item.name}</div>
                                        <ul className='mt-3'>
                                            <li className='text-base font-medium text-[#4E4E4E]'>متن کارت: {item.cardText}</li>
                                            <li className='text-base font-medium text-[#4E4E4E] mt-2'>فونت انتخابی: {item.font}</li>
                                            <li className='text-base font-medium text-[#4E4E4E] d-flex align-items-center mt-2'>
                                                <div className='d-flex align-items-center justify-content-start gap-2' style={{marginRight: '5px',marginBottom: '5px'}}>
                                                رنگ فونت: <div style={{ backgroundColor: item.fontColor, width: '16px', height: '16px', borderRadius: '2px' }}>
                                                </div></div></li>
                                            <li className='text-base font-medium text-[#4E4E4E] number' >سایز فونت: {item.fontSize}</li>
                                        </ul>
                                        <div className='  mt-3 w-100 d-flex align-items-center justify-content-between p-2 ml-5'>
                                            <div>
                                                <h5 className='number text-center color-primary text-2xl mb-0 font-semibold'>{item.price ? item.price.toLocaleString() : ''} تومان</h5>
                                                {/* <h5 className='text-xl text-center number mb-0' style={{ color: '#B8B8B8', textDecoration: 'line-through' }}>50,000</h5> */}
                                            </div>
                                            <div className="px-[8px] py-1 border-[1px] border-blue flex items-center justify-between gap-4   w-[148px] h-[44px] font-bold rounded">
                                                <div className='cursor-pointer' onClick={() => changeQuantity(item, 'add')}>
                                                    <img src={require('../../assets/icons/basket/add.svg').default} alt="" />
                                                </div>
                                                <div className='number'>{item.count}</div>
                                                <div className='cursor-pointer' onClick={() => changeQuantity(item, 'minus')}>
                                                    {item.count === 1 ? (
                                                        <img src={require('../../assets/icons/basket/trash.svg').default} alt="" />
                                                    ) : (
                                                        <img src={require('../../assets/icons/basket/minus.svg').default} alt="" />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            }



                        </div>
                        <div className='col-md-4 col-sm-12 col-lg-4'>
                            <div className='bg-[#E5ECFF] rounded-lg p-4  mt-3' style={{marginBottom: '6em'}}>
                                {/* <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='font-semibold text-sm'>قیمت کالاها (3):</h6>
                                <h6 className='font-semibold text-sm'>240.000 تومان</h6>
                            </div> */}
                                <div className='d-flex align-items-center justify-content-between  mt-2'>
                                    <h6 className='font-semibold text-sm'>جمع سبد خرید:</h6>
                                    <h6 className='font-semibold text-sm number'>{totalPrice.toLocaleString()} تومان</h6>
                                </div>
                                {/* <div className='d-flex align-items-center justify-content-between mt-3'>
                                <h6 className='font-semibold text-sm text-[#0033CC]'>سود شما از خرید:</h6>
                                <h6 className='font-semibold text-sm text-[#0033CC]'>240.000 تومان</h6>
                            </div> */}
                                <button className='btn btn-primary w-100 mt-4' type='button' onClick={() => checkLogin()}>تکمیل سفارش</button>

                            </div>
                        </div>
                    </div>) : (
                    <div className='text-center text-[#4E4E4E] text-xl font-medium mt-5'>هیچ آیتمی یافت نشد</div>
                )}
            </div>
            <div>
                {fastLogin === true && <FastLoginCom successAction={goToPayment} onClose={() => setFastLogin(false)} />}
            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </div>

    )
}

export default ShoppingCart